import React, {ChangeEvent, useEffect, useState} from 'react';
import { TextareaProps } from "./Textarea.types";
import "./Textarea.scss";

export const Textarea: React.FC<TextareaProps> = ({
    label,
    rows,
    required,
    placeholder,
    value,
    error= false,
    errorMessage,
    icon,
    iconActive,
    customClass,
    checked,
    disabled,
    name,
    onTextChange
}) => {

    const [inputValue, setInputValue] = useState<string>('');
    const [className, setClassName] = useState<string>('');

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setInputValue(e.target.value);
        if(onTextChange){
            onTextChange(e);
        }
    }

    useEffect(() => {
        setClassName(customClass ? customClass : '');
    },[inputValue]);

    return(
       <div className={"textarea-wrapper"}>
           {label && <label htmlFor={"textarea-general"}>{required && '*'} {label}</label> }
           <div className={"textarea-content"}>
               {icon && inputValue.length == 0 && <img src={icon} className={"icon"}/>}
               {iconActive && inputValue.length > 0 && <img src={iconActive} className={"icon"}/>}
               <textarea rows={rows ? rows : 2} className={error ? `input-error ${className}` : `${className}`} disabled={disabled} id={"textarea-general"} onChange={handleChange} name={name} placeholder={placeholder} value={value}></textarea>
           </div>
           {error &&
               <p className={"error-message"}>{errorMessage}</p>
           }
       </div>
    )
};

